const ATLANTIC27_MODULE = 'ATLANTIC27';
const ATLANTIC27_RESTRICTION_END = '2026-10-01';
const SESSION_KEY = 'atlantic27_code_postal_validated';
const MAXIRACE_SESSION_KEY = 'atlantic27_maxirace_selected';

export function isAtlantic27RestrictionActive(moduleBase) {
    if (moduleBase !== ATLANTIC27_MODULE) {
        return false;
    }
    return new Date() < new Date(`${ATLANTIC27_RESTRICTION_END}T00:00:00`);
}

export function isAtlantic27CodePostalValidated() {
    return sessionStorage.getItem(SESSION_KEY) === '1';
}

export function isAtlantic27MaxiraceSelected() {
    return sessionStorage.getItem(MAXIRACE_SESSION_KEY) === '1';
}

export function setAtlantic27CodePostalValidated() {
    sessionStorage.setItem(SESSION_KEY, '1');
}

export function setAtlantic27MaxiraceSelected() {
    sessionStorage.setItem(MAXIRACE_SESSION_KEY, '1');
}

export function validateAtlantic27CodePostal(codePostal) {
    return String(codePostal).trim().startsWith('44');
}

export function requiresAtlantic27CodePostalCheck(mainStore) {
    if (!isAtlantic27RestrictionActive(mainStore.module.base)) {
        return false;
    }

    if (isAtlantic27CodePostalValidated() || isAtlantic27MaxiraceSelected()) {
        return false;
    }
    return true;
}
